import { useInspectorStore } from "../store/inspectorStore";
import {
  cancelarActa,
  enviarConstatacion,
  getActa,
  getActasInspector,
} from "../services/inspector.service";
import { useGeneralAppStore } from "../store/generalAppStore";
import { setRef } from "@mui/material";

const { acta, setActa, setActas, setRefetch } = useInspectorStore.getState();
const { handlerModal } = useGeneralAppStore.getState();

export const handlerInspectorActas = async (estadoId) => {
  const result = await getActasInspector(estadoId);
  if (result) setActas(result);
};

export const handlerGetActaInspector = async (id) => {
  const result = await getActa(id);
  if (result) {
    setActa(result);
    handlerModal({ modal: true, modalName: "modal_solicitud_inspector" });
  }
};

export const handlerSubirConstatacion = async (payload) => {
  const result = await enviarConstatacion(payload);
  if (result) {
    // console.log(result)
    setActa(result);
    setRefetch(true);

    // setActa(result);
    handlerModal({ modal: false, modalName: "modal_constatacion" });
  }
};

export const handlerCancelar = async (payload) => {
  const result = await cancelarActa(payload);
  if (result) {
    setActa(result);
    setRefetch(true);
    // let { acta } = useAdminStore.getState();
    // let { defaultValues } = useFormActaStore.getState();
    // if (acta) {
    //   const refreshActas = await getActas();
    //   if (refreshActas) {
    //     setActas(refreshActas);
    //   }
    // }
    // defaultValues && setDefaultValues(result);
  }
};
